module.exports = __webpack_public_path__ + "static/img/MarkSoderstrom.8ab0218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MarkSoderstrom.jpg
// module id = 6X/i
// module chunks = 0